import { Box }            from '@chakra-ui/react';
import { Link }           from 'react-router-dom';
import PageContainer      from '@/components/pageContainer/PageContainer';
import RegistrationForm   from '@/pages/Registration/forms/RegistrationForm';
import { Stack }          from '@chakra-ui/react';
import { Text }           from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import useTranslations    from '@/hooks/useTranslations';

const RegistrationPage = () => {

	const { t } = useTranslation();
	const { getNavigationTranslation } = useTranslations();

	return (
		<PageContainer type='public'>
			<Box
				display="flex"
				alignItems="center"
				height="100%"
				justifyContent="center"
			>
				<Box
					height="100%"
					maxWidth="600px"
					display="flex"
					flexDirection="column"
					justifyContent="space-between"
					paddingTop="10px"
					paddingRight="30px"
					paddingBottom="10px"
					paddingLeft="30px"
				>
					<Stack gap="30px" >
						<Text 
							className="poppins-semibold" 
							fontSize={36}
							textAlign={{ base: "center", lg: "unset" }}
						>
							{t('pages.registration.form.title')}
						</Text>
						<RegistrationForm />
					</Stack>
					
					<Box
						display="flex"
						alignItems="center"
                        justifyContent="center"
						flexWrap="wrap"
						paddingBottom="40px"
						paddingTop="40px"
					>
						<Text>
							{t('pages.registration.form.alreadyRegistered')}
						</Text>&nbsp;
						<Link 
							to={getNavigationTranslation('login', 'path')}
						>
							<Text 
								textDecoration="underline"
								fontWeight={600}
							>
								{t('pages.registration.form.login')}
							</Text>
						</Link>
					</Box>
				</Box>
			</Box>
		</PageContainer>
	)
}

export default RegistrationPage;